import { colors } from '@chillibean/component-library';
import styled from 'styled-components';

import { WarningNavLink } from './WarningNavLink';

export function Sidebar() {
  return (
    <Wrapper>
      <Li>
        <WarningNavLink
          text="You are about to discard all the data you have entered. This action is irreversible."
          title="You have unsaved changes"
          to="/administration/chapters"
          warning={false}
        >
          Chapters
        </WarningNavLink>
      </Li>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 19.5%;
  min-width: 19.5%;
  box-sizing: border-box;
  border-right: solid 1px ${colors.grey.admin};
  display: flex;
  flex-direction: column;
  padding-top: 11px;

  a {
    text-decoration: none;
  }

  > li {
    padding: 5px;
    margin-bottom: 5px;

    > a {
      padding: 5px;

      &:hover {
        background-color: ${colors.blue.primaryAlpha('25')};
      }

      &.active {
        background-color: ${colors.blue.primaryAlpha('25')};
      }
    }
  }
`;
const Li = styled.li``;

export default Sidebar;
